import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import "./style/wishlist.css";
import Breadcrumb from "../../../Component/breadcrumb/Breadcrumb";
import ModalBoxPopupwish from "../wishlist/component/ModalBoxPopupwish";
import { Toaster } from "react-hot-toast";
import { fetchWishlist, deleteWishlist } from "./redux/wishlistSlice";
import wislistempty from "../../../assets/images/wsihlist.png";

function Wishlist() {
  const dispatch = useDispatch();
  const {
    wishlist = [],
    loading,
  } = useSelector(
    (state) => state.wishlist
  );

  const [detailModalShow, setDetailModalShow] = useState(false);
  const [currentImage, setCurrentImage] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const userId =
    localStorage.getItem(
      "user_id"
    );
  const customerId =
    localStorage.getItem(
      "customer_id"
    );

  // =====================================================
  // GET WISHLIST PRODUCT LISTING ID
  // =====================================================

  const getProductListingId = (
    item
  ) => {
    return Number(
      item?.product_listing_id ||
        item?.productListingId ||
        item?.listing_id ||
        item?.listingId ||
        item?.product_id ||
        item?.productId ||
        0
    );
  };

  // =====================================================
  // GET WISHLIST ID
  // =====================================================

  const getWishlistId = (
    item
  ) => {
    return (
      item?.id ||
      item?.wishlist_id ||
      item?.wishlistId ||
      item?.wishlistID ||
      null
    );
  };

  // =====================================================
  // FETCH WISHLIST
  // =====================================================

  useEffect(() => {
    if (
      userId &&
      customerId
    ) {
      dispatch(
        fetchWishlist({
          userId,
          customerId,
        })
      );
    }
  }, [
    dispatch,
    userId,
    customerId,
  ]);

  // =====================================================
  // CART SUCCESS EVENT
  // =====================================================

  useEffect(() => {
    const handleProductAddedToCart = (
      event
    ) => {
      const data =
        event?.detail || {};
      const addedProductListingId =
        Number(
          data?.product_listing_id
        );

      const addedCustomerId =
        Number(
          data?.customer_id
        );

      const currentCustomerId =
        Number(
          localStorage.getItem(
            "customer_id"
          )
        );

      if (
        !addedProductListingId
      ) {
        console.warn(
          "Product listing ID missing in cart event"
        );

        return;
      }

      if (
        addedCustomerId &&
        currentCustomerId &&
        addedCustomerId !==
          currentCustomerId
      ) {
        return;
      }

      // =================================================
      // FIND PRODUCT IN WISHLIST
      // =================================================

      const wishlistItem =
        wishlist.find(
          (item) => {
            const wishlistProductListingId =
              getProductListingId(
                item
              );

            return (
              wishlistProductListingId ===
              addedProductListingId
            );
          }
        );

      if (
        !wishlistItem
      ) {
        return;
      }

      // =================================================
      // GET WISHLIST ID
      // =================================================

      const wishlistId =
        getWishlistId(
          wishlistItem
        );

      if (!wishlistId) {
        console.warn(
          "Wishlist ID not found",
          wishlistItem
        );

        return;
      }

      // =================================================
      // DELETE WISHLIST
      // =================================================

      dispatch(
        deleteWishlist({
          wishlistId,
          userId:
            localStorage.getItem(
              "user_id"
            ),
          customerId:
            localStorage.getItem(
              "customer_id"
            ),
        })
      );
    };

    window.addEventListener(
      "productAddedToCart",
      handleProductAddedToCart
    );

    return () => {
      window.removeEventListener(
        "productAddedToCart",
        handleProductAddedToCart
      );
    };
  }, [
    wishlist,
    dispatch,
  ]);

  // =====================================================
  // SHOW DETAIL
  // =====================================================

  const handleShow = (
    item
  ) => {
    setSelectedProduct(item);

    setCurrentImage(
      item?.image ||
        item?.product_image ||
        item?.image_url ||
        ""
    );
    setDetailModalShow(
      true
    );
  };

  // =====================================================
  // CLOSE DETAIL
  // =====================================================

  const handleDetailModalClose =
    () => {
      setDetailModalShow(
        false
      );

      setCurrentImage("");
      setSelectedProduct(
        null
      );
    };

  // =====================================================
  // MANUAL REMOVE
  // =====================================================

  const handleRemoveWishlist = (
    wishlistId
  ) => {
    if (!wishlistId) {
      return;
    }

    dispatch(
      deleteWishlist({
        wishlistId,
        userId,
        customerId,
      })
    );
  };

  // =====================================================
  // UI
  // =====================================================

  return (
    <>
      <Breadcrumb
        items={[
          {
            name: "Wishlist",
            path: "/wishlist",
          },
        ]}
      />

      <Toaster
        position="top-right"
        reverseOrder={false}
      />

      <section className="wishlist pt-2">
        <div className="container">
          <div className="row row-cols-2 row-cols-md-3 row-cols-xl-5 g-3">
            {loading ? (
              <div className="col-12 text-center">
                <h5>
                  Loading...
                </h5>
              </div>
            ) : wishlist.length ===
              0 ? (
              <div className="col-12 text-center w-100">
                <img
                  src={wislistempty}
                  alt="Your Wishlist is Empty"
                  width={230}
                  style={{
                    margin:
                      "0 auto",
                  }}
                />

                <h5
                  style={{
                    fontSize:
                      "25px",
                  }}
                >
                  Your Wishlist is
                  Empty
                </h5>

                <p
                  className="mb-5"
                  style={{
                    fontSize:
                      "19px",
                  }}
                >
                  You haven’t added
                  any products to your
                  wishlist yet.
                </p>
              </div>
            ) : (
              wishlist.map(
                (
                  item,
                  index
                ) => {
                  const wishlistId =
                    getWishlistId(
                      item
                    );

                  return (
                    <div
                      className="col"
                      key={
                        wishlistId ||
                        index
                      }
                    >
                      <div className="box">
                        {/* IMAGE */}
                        <div
                          className="boximages"
                          onClick={() =>
                            handleShow(
                              item
                            )
                          }
                        >
                          <img
                            src={
                              item?.image ||
                              item?.product_image ||
                              item?.image_url
                            }
                            alt={
                              item?.product_name ||
                              "Product"
                            }
                          />
                        </div>

                        {/* TITLE */}
                        <div className="box-title d-flex justify-content-between">
                          <p className="mb-0">
                            {item?.quality_name}

                            <span className="d-block">
                              {
                                item?.design_shade
                              }
                            </span>
                          </p>

                          <Link
                            to="#"
                            className="text-yellow"
                            onClick={(
                              e
                            ) => {
                              e.preventDefault();

                              handleRemoveWishlist(
                                wishlistId
                              );
                            }}
                          >
                            <i className="bi bi-trash"></i>
                          </Link>
                        </div>
                      </div>
                    </div>
                  );
                }
              )
            )}
          </div>
        </div>
      </section>

      {/* =================================================
                DETAIL MODAL
      ================================================= */}

      <ModalBoxPopupwish
        Modal={Modal}
        Button={Button}
        detailModalShow={ detailModalShow }
        handleDetailModalClose={ handleDetailModalClose }
        currentImage={ currentImage }
        product={ selectedProduct}
      />
    </>
  );
}
export default Wishlist;